export default __webpack_public_path__ + "static/media/clinical.7430ea3a.svg";